
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set } from "firebase/database";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA8lPcH2GF_77HoyA7EZJoJbP65nasabps",
  authDomain: "niyplms0603tcycj.firebaseapp.com",
  databaseURL: "https://niyplms0603tcycj-default-rtdb.firebaseio.com",
  projectId: "niyplms0603tcycj",
  storageBucket: "niyplms0603tcycj.firebasestorage.app",
  messagingSenderId: "7490384481",
  appId: "1:7490384481:web:0deed22531fd88ecd3f020",
  measurementId: "G-Z008FY9V7Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get a reference to the database
const db = getDatabase(app);

export { db, ref, set };
